import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as ArrowIcon } from '../assets/icons/16/arrow_down.svg';
import { THEME_MODES } from '../theme';
import SvgIcon from './SvgIcon';
import { getStatusConfigs } from '../helpers/status';

const StatusBadge = ({ variant, children, sx, active, onClick }) => {
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === THEME_MODES.DARK;

  const config = getStatusConfigs(variant, isDarkMode);

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: 16,
        border: `1px solid ${config.badgeBorder || '#ffffff'}`,
        height: 27,
        minWidth: 95,
        justifyContent: 'center',
        padding: '0px 12px',
        backgroundColor: config.badgeBackground || '#ffffff',
        fontSize: 12,
        letterSpacing: 0.06,
        fontWeight: 600,
        color: config.textColor || '#000000',
        ...sx,
      }}
    >
      {children || config.label}
      {active && (
        <SvgIcon icon={ArrowIcon} color={config.textColor} size={16} sx={{ marginLeft: 0.5 }} />
      )}
    </Box>
  );
};

export default StatusBadge;
